module.exports = __webpack_public_path__ + "img/like.77b661ae.png";